<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" :overlay="false" scrollable fullscreen>
    <v-card tile flat>
      <v-toolbar dark color="primary">
        <v-app-bar-nav-icon><v-icon>fa-credit-card</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title class="pl-4">Add a new product for {{ selectedFunder.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0" style="height: 100vh">
        <v-card flat tile class="py-2 pl-4 ma-0 mb-5">
          <v-card-text class="pa-0">
            <v-form lazy-validation>
              <v-container fluid grid-list-md class="pa-0">
                <v-layout wrap>
                  <v-flex xs4>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field label="Product name" v-model="product.name" required></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          auto-grow
                          counter
                          max="160"
                          label="Description"
                          v-model="product.description"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          label="Journey"
                          v-model="product.journey_id"
                          :items="journeys"
                          item-text="name"
                          item-value="id"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          label="Product type"
                          v-model="product.product_type_id"
                          :items="ProductTypes"
                          item-text="name"
                          item-value="id"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field label="Phone" v-model="product.phone"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field label="Traceable URL" v-model="product.traceable_url"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field label="Address Line 1" v-model="product.address_1" required></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field label="Address Line 2" v-model="product.address_2"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field label="Address Line 3" v-model="product.address_3"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field label="Address Line 4" v-model="product.address_4"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field label="Address Line 5" v-model="product.address_5"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field label="Post Code" v-model="product.post_code" required></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          label="Registered Company Name"
                          v-model="product.registered_company_name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          label="Registered Company Number"
                          v-model="product.registered_company_number"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
        <v-btn class="ml-4" color="accent" @click.native="register" :disabled="!isValidProduct">Add</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'new-product-dialog',
  props: ['show', 'selectedFunder'],
  data: () => ({
    product: {
      name: null,
      description: null,
      business_id: null,
      journey_id: null,
      logo: null,
      product_type_id: null,
      phone: null,
      address_1: null,
      address_2: null,
      address_3: null,
      address_4: null,
      address_5: null,
      post_code: null,
      traceable_url: null,
      registered_company_name: null,
      registered_company_number: null
    }
  }),
  computed: {
    ...mapGetters(['ProductTypes', 'JourneyTypes']),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    verifiedEmail: {
      get() {
        return this.email;
      },
      set: _.debounce(function(email) {
        this.email = email;
        this.verifyRegistrationEmail(email);
      }, 500)
    },
    journeys: function() {
      return _.isNull(this.JourneyTypes[0].id) ? [] : this.JourneyTypes[1].journeys;
    },
    isValidProduct: function() {
      return this.product.name !== null && this.product.product_type_id !== null && this.product.journey_id !== null;
    }
  },
  methods: {
    ...mapActions(['addProduct', 'getJourneyTypes']),
    clearRegistration() {
      this.product = {
        name: null,
        description: null,
        business_id: null,
        journey_id: null,
        logo: null,
        product_type_id: null,
        phone: null,
        address_1: null,
        address_2: null,
        address_3: null,
        address_4: null,
        address_5: null,
        post_code: null,
        traceable_url: null,
        registered_company_name: null,
        registered_company_number: null
      };
    },
    register() {
      this.product.business_id = this.selectedFunder.provider.id;
      this.product.logo = this.selectedFunder.logo;
      this.addProduct(this.product).then(this.closeDialog());
    },
    closeDialog() {
      this.clearRegistration();
      this.dialog = false;
    },
    startCase: function(str) {
      str = _.lowerCase(str);
      return _.startCase(str);
    },
    isDefined: function(value) {
      return _.isUndefined(value) === false;
    },
    isFilled: function(value) {
      return !_.isEmpty(value);
    }
  },
  mounted() {
    if (_.isNull(this.JourneyTypes[0].id)) {
      this.getJourneyTypes();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
